import { css } from '@emotion/css';
import { ChipItem } from 'models/txcb-model';
import { forwardRef } from 'react';

const chipInit: ChipItem[] = [
    {
        txt: '5K',
        val: 5000,
        isActive: false,
        icon: 'chip1.png',
    },
    {
        txt: '10K',
        val: 10000,
        isActive: false,
        icon: 'chip2.png',
    },
    {
        txt: '50K',
        val: 50000,
        isActive: false,
        icon: 'chip3.png',
    },
    {
        txt: '100K',
        val: 100000,
        isActive: false,
        icon: 'chip4.png',
    },
    {
        txt: '200K',
        val: 200000,
        isActive: false,
        icon: 'chip5.png',
    },
    {
        txt: '500K',
        val: 500000,
        isActive: false,
        icon: 'chip6.png',
    },
    {
        txt: '1M',
        val: 1000000,
        isActive: false,
        icon: 'chip7.png',
    },
    {
        txt: '2M',
        val: 10000000,
        isActive: false,
        icon: 'chip8.png',
    },
    {
        txt: '5M',
        val: 5000000,
        isActive: false,
        icon: 'chip9.png',
    },
];

interface Props {
    valueActive: number;
    onSelect: (chip: ChipItem) => void;
    slideItem?: number;
}
function ChipRongHo(props: Props, ref: any) {
    const { valueActive, onSelect } = props;
    return (
        <div className={styles.chipContainer}>
            {chipInit.map((item, index) => (
                <button
                    key={index}
                    type="button"
                    className={`chip-item ${item.val === valueActive ? 'active' : ''}`}
                    onClick={() => onSelect(item)}
                    ref={(el) => (ref.current[index] = el)}
                    datatype={String(item.val)}
                >
                    <img src={require(`assets/images/chips/${item.icon}`)} alt="coin" />
                    <p>{item.txt}</p>
                </button>
            ))}
        </div>
    );
}

export default forwardRef(ChipRongHo);

const styles = {
    chipContainer: css`
    display: flex;
        .chip-item {
            padding: 6px;
            position: relative;
            border-radius: 40px;
            &:active {
                transform: scale(0.95);
                img {
                    filter: drop-shadow(0 0 4px var(--ion-color-secondary));
                }
            }

            p {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 12px;
                font-weight: 800;
                color: #fff;
            }
        }
    `,
};
